<template lang="">
    <div class="bbs_filter">
      <div class="lft_area">
        <div class="bbs_info">
          <div class="total"><strong>
            {{ getCurrentCount() }}
          </strong> / {{ this.sponsorListCount }}</div>
        </div>
      </div>
      <div class="rgt_area">
        <div class="bbs_srch">
          <select name="" id="" class="i_sel" v-model="searchType">
            <option
              v-for="option in searchOptions"
              :value="option.value"
            >{{ option.name }}</option>
          </select>
          <input type="text" class="i_txt" name="keyword" v-model="searchWord">
          <button type="button" class="bt_base gray btn_srch" @click="getSearch">검색</button>
        </div>
      </div>
    </div>
  
    <div class="bbs_list">
      <table class="bbs_tbl">
        <colgroup>
          <col style="width:5%">
          <col style="width:5%">
          <col style="width:20%">
          <col style="width:25%">
          <col style="width:auto">
          <col style="width:25%">
          <col style="width:auto">
        </colgroup>
        <thead>
          <tr>
            <th scope="col"><span class="ui_chkbox primary nontxt"><input type="checkbox" name="" @change="toggleAllCheck($event.target.checked)"><label for=""></label></span></th>
            <th scope="col">번호</th>
            <th scope="col">제목</th>
            <th scope="col">내용</th>
            <th scope="col">후원액</th>
            <th scope="col">기간</th>
            <th scope="col">등록일</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(sponsor, index) in sponsorList"
          >
            <td>
              <span class="ui_chkbox primary nontxt">
                <input
                  type="checkbox" 
                  :value="sponsor.sponsorSeq"
                  v-model="selectedSponsors"
                >
                <label for=""></label></span>
            </td>
            <td>{{ index + 1 }}</td>
            <td><span class="medium">{{ $truncateText(sponsor.title, 10) }}</span></td>
            <td class="subject"><a @click="toSponsor(sponsor.sponsorSeq)">{{ $truncateText(sponsor.content, 25) }}</a></td>
            <td>
              <div class="ui_datetime">
                <span class="date">{{ $addComma(sponsor.sponsorAmount) }}</span>
              </div>
            </td>
            <td>
                <span class="time">{{ sponsor.startDate + " ~ " + sponsor.endDate }}</span>
            </td>
            <td>{{ sponsor.createDate }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  
    <div class="paginate">
      <AdminPagination
        :totalPages = "totalPages()"
        :currentPage = "currentPage"
        @changePage = "changePage"
      />
  
      <div class="rgt_area">
        <button type="button" class="bt_base primary large_h" @click="createSponsor">등록</button>
        <button type="button" class="bt_base gray large_h" @click="deleteSelectedSponsors">삭제</button>
      </div>
    </div>
  </template>
  <script>
  import { mapActions, mapState } from 'vuex';
  import AdminPagination from '@/components/common/AdminPagination.vue';
  
  const adminSponsorModule = 'adminSponsorModule'
  
  export default {
    components: {
      AdminPagination
    },
  
    data () {
      return {
        currentPage: 1,
        selectedSponsors: [],
  
        searchOptions: [
          { name: '전체', value: 'all' },
        ],
        searchType: '',
        searchWord: ''
      }
    },
  
    methods: {
      ...mapActions(adminSponsorModule, [
        'requestSponsorList',
        'requestDeleteSponsors'
      ]),

      createSponsor() {
        this.$router.push({ name: "SponsorManageCreatePage" })
      },
  
      toSponsor(sponsorSeq) {
        this.$router.push({
          name: "SponsorManageCreatePage",
          query: { sponsorSeq: sponsorSeq },
        });
      },
  
      totalPages() {
        return Math.ceil(this.sponsorListCount / 10);
      },
  
      async changePage(page) {
        this.currentPage = page
        const {currentPage, searchType, searchWord} = this
        await this.requestSponsorList({currentPage, searchType, searchWord})
      },
  
      getCurrentCount() {
        const currentFirstCount = (this.currentPage - 1) * 10 + 1
        let currentLastCount = this.currentPage * 10
        if (parseInt(currentLastCount) > parseInt(this.sponsorListCount)) {
          currentLastCount = this.sponsorListCount
        }
        return currentFirstCount + '-' + currentLastCount
      },
  
      toggleAllCheck(isChecked) {
        if (isChecked) {
          this.selectedSponsors = []
          for (const sponsor of this.sponsorList) {
            this.selectedSponsors.push(sponsor.sponsorSeq)
          }
        } else {
          this.selectedSponsors = []
        }
      },
  
      async deleteSelectedSponsors() {
        if (this.selectedSponsors.length === 0) {
          alert('선택된 후원활동이 없습니다');
          return;
        }
  
        const { searchType, searchWord, currentPage } = this;
        const fetchSponsors = async (page = 1, type = searchType, word = searchWord, isReset = false) => {
          const params = { currentPage: page, searchType: type, searchWord: word };
          await this.requestSponsorList(params);
          if (isReset) {
            this.searchType = 'all';
          }
        };
  
        await this.requestDeleteSponsors(this.selectedSponsors);
        this.selectedSponsors = [];
  
        await fetchSponsors(currentPage);
  
        if (this.sponsorList.length === 0 && this.currentPage > 1) {
          this.currentPage -= 1;
          await fetchSponsors(this.currentPage);
        }
  
        if (this.sponsorList.length === 0 || this.currentPage === 1) {
          this.currentPage = 1;
          this.searchType = '';
          this.searchWord = '';
          await fetchSponsors(1, '', '', true);
        }
      },
  
      async getSearch() {
        if (this.searchWord === '') {
          alert('검색어를 입력해주세요')
          return
        }
        this.currentPage = 1
        const {currentPage, searchType, searchWord} = this
        await this.requestSponsorList({currentPage, searchType, searchWord})
      }
    },
  
    computed: {
      ...mapState(adminSponsorModule, [
        'sponsorList',
        'sponsorListCount'
      ])
    },
  
    async mounted() {
      const {currentPage, searchType, searchWord} = this
      await this.requestSponsorList({currentPage, searchType, searchWord})
      this.searchType = 'all'
    }
  }
  </script>
  <style lang="">
      
  </style>